import React, { useState, useRef, useMemo } from 'react'
import { connect } from 'react-redux'
import * as actions from '../redux/actions'
import useLanguage from '../hooks/useLanguage'
import Header from '../components/Header'
import '../styles/containers/Agenda.css'
import 'react-day-picker/lib/style.css'

import text from '../constants/Agenda'
import { FiArrowLeft } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

const months = [[
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
],
[
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
],
[
  'Enero',
  'Julio',
  'Marzo',
  'Marzo',
  'Mayo',
  'Julio',
  'Julio',
  'Septiembre',
  'Septiembre',
  'October',
  'Noviembre',
  'Diciembre'
]]

const weekdaysShort = [[
  'Dom',
  'Seg',
  'Ter',
  'Qua',
  'Qui',
  'Sex',
  'Sáb'
],
[
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat'
],
[
  'Dom',
  'Lun',
  'Mar',
  'Mie',
  'Jue',
  'Vie',
  'Sab'
]]

const Agenda = props => {
  const language = useLanguage()
  const { push } = useHistory()
  const monthsFilterRef = useRef()

  const currentYear = useMemo(() => moment().year(), [])
  const currentMonth = useMemo(() => moment().month(), [])
  const currentDay = useMemo(() => moment().date(), [])

  // selected index of 'months[language]' array, always initialize with the current month
  const [selectedMonth, setSelectedMonth] = useState(
    currentMonth
  )

  // year of selected calendar page
  const [selectedYear, setSelectedYear] = useState(
    currentYear
  )

  // in the future, the next events will have more than one element
  const nextEvents = useMemo(() => props.user.agenda.results.length > 0 ? props.user.agenda.results : [], [props.user.agenda.results])

  // render the next 6 months, starting from the current month
  const renderMonths = () => {
    // stores the year of the month being mapped on array, if the month in the loop is
    // december, the next month, if rendered, surely will be of the next year
    let monthYear = currentYear

    // stores the month being mapped on array
    let currentMonthToRender = currentMonth

    // create an array with length 6, with the next 6 months starting from now and their respective years
    const nextMonths = (new Array(6).fill(0).map(() => {
      const month = { monthNumber: currentMonthToRender, year: monthYear }

      if (currentMonthToRender === 11) {
        monthYear++
      }

      currentMonthToRender = (currentMonthToRender + 1) % 12

      return month
    }))

    return (
      // create an array with length 6 and map the values with the months names based on the selected language
      <div className='agenda-screen-months' ref={monthsFilterRef}>
        {nextMonths.map(month => {
          return (
            <div key={month.monthNumber} className={`agenda-screen-month${month.monthNumber === selectedMonth ? ' selected' : ''}`}
              onClick={() => {
                setSelectedMonth(month.monthNumber)
                setSelectedYear(month.year)
              }}>
              {months[language][month.monthNumber]}
            </div>
          )
        })}
      </div>
    )
  }

  const renderWeekDays = () => {
    return (
      <div className='agenda-screen-calendar-inner-weekdays'>
        {(new Array(7)).fill(0).map((_, index) => {
          return (
            <p key={index}>{weekdaysShort[language][index]}</p>
          )
        })}
      </div>
    )
  }

  const renderDays = () => {
    const selectedCalendarMonth = moment().year(selectedYear).month(selectedMonth)
    const monthNumber = selectedCalendarMonth.month()

    const daysInSelectedCalendarMonth = selectedCalendarMonth.daysInMonth()
    const monthFirstWeekDay = selectedCalendarMonth.startOf('month').day()

    const daysInPreviousMonth = selectedCalendarMonth.startOf('month').subtract(1, 'month').daysInMonth()

    // amount of days of previous month that will appear in this calendar page
    // example: if the first week day of the current month will be wednesday,
    // the last 3 days: sunday, monday and tuesday of the previous month will
    // be displayed in the calendar page
    const previousMonthDaysInThisCalendarPage = monthFirstWeekDay % 7

    // this variable will count the previous month days left to be showed
    let previousMonthDaysLeft = previousMonthDaysInThisCalendarPage

    let selectedCalendarMonthDaysLeft = daysInSelectedCalendarMonth

    // when all days of current month were showed, fill the left spaces with days
    // of next month, this variable will store the day that will be stored
    let nextMonthDaysToFill = 1

    const daysOfCalendarPage = (new Array(42).fill(0)).map((_, index) => {
      let dayToShow
      if (previousMonthDaysLeft > 0) {
        // calculate the month day to be showed
        dayToShow = daysInPreviousMonth - previousMonthDaysLeft + 1
        previousMonthDaysLeft--
        return { day: dayToShow, month: monthNumber === 0 ? 11 : monthNumber - 1 }
      }

      if (selectedCalendarMonthDaysLeft > 0) {
        dayToShow = daysInSelectedCalendarMonth - selectedCalendarMonthDaysLeft + 1
        selectedCalendarMonthDaysLeft--
        return { day: dayToShow, month: monthNumber }
      }

      dayToShow = nextMonthDaysToFill
      nextMonthDaysToFill++

      return { day: dayToShow, month: (monthNumber + 1) % 12 }
    })

    const nextEventsDates = nextEvents.map(event => {
      return { day: moment(event.time).date(), month: moment(event.time).month() }
    })

    return (
      <div className='agenda-screen-calendar-inner-days'>
        {daysOfCalendarPage.map((date) => {
          // finds if there is an event in this date
          const hasEvent = nextEventsDates.find(event => event.day === date.day && event.month === date.month)

          return (
            <div className={`agenda-screen-celendar-inner-day
                            ${date.month !== selectedMonth ? ' other-month' : ''}
                            ${date.month === currentMonth && date.day === currentDay ? ' today' : ''}`} key={`${date.day}-${date.month}`}>
              {date.day}
              {hasEvent && <div className='event-circle' />}
            </div>
          )
        })}
      </div>
    )
  }

  const renderNextEvents = () => {
    return (
      <div className='agenda-screen-next-events'>
        <p>Próximos eventos</p>
        {nextEvents.map(event => {
          const eventMonth = moment(event.time).month()
          const eventYear = moment(event.time).year()

          return (
            <div key={event.id} className='agenda-screen-event'
              onClick={() => {
                setSelectedMonth(eventMonth)
                setSelectedYear(eventYear)
              }}
            >
              <p className='agenda-screen-event-street'>
                {event.place}
              </p>
              <p className='agenda-screen-event-data'>
                {moment(event.time).format('DD/MM/YYYY 🞄 HH:mm')}
              </p>
            </div>
          )
        })}
        {nextEvents.length === 0 && (
          <div className='agenda-screen-events-empty'>
            Nenhum evento encontrado
          </div>
        )}
      </div>
    )
  }

  return (
    <div className='agenda-screen-container'>
      <Header language={language} />
      <div className='agenda-screen-title'>
        <FiArrowLeft onClick={() => push('/')}
          size={24} color='var(--primary)' className='agenda-screen-goback' />
        <p>{text.title[language]}</p>
      </div>
      <div className='agenda-screen-events'>
        {renderMonths()}
        <div className='agenda-screen-calendar'>
          <div className='agenda-screen-calendar-inner'>
            <p>{months[language][selectedMonth]} {selectedYear}</p>
            {renderWeekDays()}
            {renderDays()}
          </div>
        </div>
        {renderNextEvents()}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(Agenda)



// WEBPACK FOOTER //
// ./src/containers/Agenda.js